'use client'
import { GetUserProfileImage } from '@/app/dashboard/chat-bot/actions'
import { MenuIcon } from 'lucide-react'
import React, { useEffect, useState } from 'react'

interface IUserIconParams {
    userPicture?: string | null,
    userId?: string | null,
    photoOnly?: boolean
}

function UserIcon(params: IUserIconParams ) {
  const [profileImage, setProfileImage] = useState<string | null | undefined>(null);


  useEffect(() => {
    // Resolve the promise inside the effect
    if(params.userId) GetUserProfileImage(params.userId).then((url) => setProfileImage(url));
    else setProfileImage(params.userPicture);
  }, [params.userId, params.userPicture]);

  if(!params.photoOnly) {
    return (
      <div className="rounded-full border-2 border-indigo-300 px-2 py-2 lg:px-4 lg-py-2 flex items-center gap-x-3">
          <MenuIcon className="w-6 h-6 lg:w-6 lg:h-6 text-indigo-600" />
  
          <img src={ profileImage ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png" }
              alt="User Image Icon"
              className="rounded-full h8 w-8 hidden lg:block" referrerPolicy={'no-referrer'}
          />
      </div>
    )
  } else  {
    return (
      <div className="rounded-full h-8 w-8">
          <img src={ profileImage ?? "https://cdn-icons-png.flaticon.com/512/149/149071.png" }
              alt="User Image Icon"
              className="rounded-full h-8 w-8 block object-cover" 
              referrerPolicy={'no-referrer'}
          />
      </div>
    )
  }
}

export default UserIcon